import React from 'react';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ChevronLeft';
import { useNavigate } from 'react-router-dom';
import { getReturnToForEvents } from '../../utils/navigationReturnTo';

const BackButton: React.FC = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(getReturnToForEvents());
    };

    return (
        <Button
            startIcon={<ArrowBackIcon />}
            onClick={handleBack}
            aria-label="Back to events"
            sx={{ color: 'black', backgroundColor: '#E0E0E0' }}
        >
            Back
        </Button>
    );
};

export default BackButton;